import { createClient } from "@pankod/refine-supabase";

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;

const supabaseClient = createClient(REACT_APP_SUPABASE_URL!, REACT_APP_SUPABASE_KEY!);

export default supabaseClient;
